import { ArrowRight, Phone, Clock, CheckCircle2, Mail, Instagram, MessageCircle } from "lucide-react";
import { site } from "../../lib/siteConfig";
import { ContactForm } from "./ContactForm";

export const CTA = () => {
  const bullets = [
    "Analisi preliminare del tuo immobile",
    "Scenario di rendita netta realistica",
    "Indicazioni chiare sui prossimi passi",
  ];

  return (
    <section
      id="contatti"
      data-testid="cta-section"
      className="relative bg-white py-24 sm:py-32 border-t border-brand-line"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-14 items-start">
          <div className="lg:col-span-6 bg-brand-ink text-white p-10 sm:p-12 lg:p-14 rounded-sm relative overflow-hidden grain-overlay lg:sticky lg:top-28">
            <p
              data-testid="cta-eyebrow"
              className="inline-flex items-center gap-3 text-xs uppercase tracking-[0.25em] font-semibold text-brand-beige"
            >
              <Phone size={14} />
              Chiamata · 30 min
            </p>
            <h2
              data-testid="cta-headline"
              className="font-display text-4xl sm:text-5xl lg:text-[3rem] leading-[1.05] font-bold mt-6"
            >
              Prenota una call<br />
              <span className="italic font-normal text-brand-beige">e facciamo i conti veri.</span>
            </h2>
            <p
              data-testid="cta-paragraph"
              className="mt-7 text-base sm:text-lg leading-relaxed text-white/75 max-w-lg"
            >
              Una mezz'ora insieme per capire quanto davvero sta rendendo il tuo immobile e quale formula può
              migliorare il tuo margine netto. Senza impegno.
            </p>

            <ul className="mt-7 space-y-3 max-w-md">
              {bullets.map((b) => (
                <li key={b} className="flex items-start gap-3 text-white/90">
                  <CheckCircle2 size={18} className="text-brand-beige mt-0.5" strokeWidth={2} />
                  <span className="text-sm sm:text-base">{b}</span>
                </li>
              ))}
            </ul>

            <a
              href={site.calendly}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="cta-primary-button"
              className="group mt-9 inline-flex items-center gap-3 bg-white text-brand-ink font-medium px-7 py-3.5 rounded-sm hover:bg-brand-beige transition-all"
            >
              Prenota ora su Calendly
              <ArrowRight size={18} className="transition-transform group-hover:translate-x-1" />
            </a>

            <div className="mt-5 text-xs text-white/50 flex items-center gap-2">
              <Clock size={12} /> Gratuita · Nessun vincolo · 30 minuti
            </div>

            <div className="mt-10 pt-8 border-t border-white/10 flex flex-wrap items-center gap-x-6 gap-y-3 text-sm">
              <a
                href={site.whatsappUrl}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="cta-whatsapp-link"
                className="inline-flex items-center gap-2 text-white/85 hover:text-white transition-colors"
              >
                <MessageCircle size={14} />
                WhatsApp
              </a>
              <a
                href={`mailto:${site.email}`}
                data-testid="cta-email-link"
                className="inline-flex items-center gap-2 text-white/80 hover:text-white transition-colors"
              >
                <Mail size={14} />
                {site.email}
              </a>
              <a
                href={site.instagram}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="cta-instagram-link"
                className="inline-flex items-center gap-2 text-white/80 hover:text-white transition-colors"
              >
                <Instagram size={14} />
                {site.instagramHandle}
              </a>
            </div>
          </div>

          <div className="lg:col-span-6">
            <ContactForm />
          </div>
        </div>
      </div>
    </section>
  );
};
